import { FC, useContext } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button } from '@microservices/wiskey-react-components'
import { Add as AddIcon } from '@mui/icons-material'
import { Grid } from '@mui/material'

import { useFetchAllCriteriaByObjectCodesQuery } from '@redux/api'

import { SearchAssistantsCreateOrEditContext } from '../../SearchAssistantsCreateOrEdit'

import { getDefaultValues } from './helpers/getDefaultValues'
import { SearchFilterForm } from './AddSearchFilterDialog'
import { ValueInputs } from './ValueInputs'

type SearchFilterValueFormInputsProps = unknown

export const SearchFilterValueFormInputs: FC<SearchFilterValueFormInputsProps> = () => {
  const { control, watch } = useFormContext<SearchFilterForm>()
  const { objects, searchAssistantId, templates } = useContext(SearchAssistantsCreateOrEditContext)
  const {
    fields: searchFilterArrayInputs,
    append,
    remove,
  } = useFieldArray({
    control,
    name: 'values',
  })
  const { t } = useTranslation()

  const watchedObject = watch('object')

  const disabledAdding = !watchedObject?.id
  const disabledRemoving = searchFilterArrayInputs.length <= 1

  const { data: filtersByObjectCode } = useFetchAllCriteriaByObjectCodesQuery(
    {
      objectCodes: watchedObject?.id ? [watchedObject.id as string] : [],
      searchAssistantId,
    },
    {
      skip: !watchedObject?.id || !searchAssistantId,
    }
  )

  const handleAddButtonClick = () => {
    if (disabledAdding) {
      return
    }
    const { values } = getDefaultValues()
    const emptyValue = values[0]
    append(emptyValue)
  }

  const handleDeleteButtonClick = (index: number) => {
    remove(index)
  }

  return (
    <>
      {searchFilterArrayInputs.map((field, index) => (
        <ValueInputs
          key={field.id}
          addedFiltersByObject={filtersByObjectCode?.data || []}
          {...{ index, disabledRemoving, handleDeleteButtonClick }}
        />
      ))}
      <Grid container>
        <Grid item>
          <Button
            disabled={disabledAdding}
            startIcon={<AddIcon />}
            sx={{ mt: 0.5 }}
            onClick={handleAddButtonClick}
          >
            {t('searchFilterForm.value.addButtonTitle')}
          </Button>
        </Grid>
      </Grid>
    </>
  )
}
